import type { Workspace } from 'src/services/IntentService';

export function resolveWorkspace(projects: Workspace[], requested: string | null): Workspace | null {
    if (requested === null) return projects[0] || null;
    if (!/^[1-9]\d*$/.test(requested) || !Number.isSafeInteger(Number(requested))) return null;
    return projects.find((project) => project.id === Number(requested)) || null;
}
